import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useState } from "react";

import { LabelText } from "../typography/Typography";
import CollapsibleContent from "../collapsible-content/CollapsibleContent";

/**
 * Bordered section that collapses its body. Title on the left, optional
 * actions (shown while open) and the chevron on the right.
 */
const CollapsibleSection = ({
    title,
    children,
    actions,
    contentId,
    dataCy,
    defaultOpen = true,
    className = "",
    /** Accessible name for the toggle when `title` is not a plain string. */
    titleLabel,
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);
    const toggleLabel = titleLabel || (typeof title === "string" ? title : "section");

    return (
        <section className={`rounded-md border border-gray-100 bg-gray-50 p-4 ${className}`.trim()}>
            <div className="flex items-center gap-2">
                <LabelText weight="normal">{title}</LabelText>
                <div className="ml-auto flex items-center gap-2">
                    {isOpen && actions}
                    <button
                        type="button"
                        onClick={() => setIsOpen((current) => !current)}
                        aria-expanded={isOpen}
                        aria-controls={contentId}
                        aria-label={`${isOpen ? "Collapse" : "Expand"} ${toggleLabel}`}
                        title={`${isOpen ? "Collapse" : "Expand"} ${toggleLabel}`}
                        data-cy={dataCy}
                        className="inline-flex h-8 w-8 items-center justify-center rounded-md text-slate-600 hover:bg-white/80 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-600"
                    >
                        {isOpen ? (
                            <ChevronUp className="h-5 w-5" aria-hidden="true" />
                        ) : (
                            <ChevronDown className="h-5 w-5" aria-hidden="true" />
                        )}
                    </button>
                </div>
            </div>
            <CollapsibleContent isOpen={isOpen} id={contentId}>
                <div className="pt-3">{children}</div>
            </CollapsibleContent>
        </section>
    );
};

export default CollapsibleSection;
